import { FolderOpenIcon } from 'foundations-assets/icons/components/FolderOpenIcon';
import { SearchIcon } from 'foundations-assets/icons/components/SearchIcon';
import { TagIcon } from 'foundations-assets/icons/components/TagIcon';
import { Image } from 'foundations-components/transitional/components/Image';
import unescapedText from 'I18n/utils/unescapedText';
import { buildCategoryUrl, buildCollectionUrl, buildListingUrl, buildSearchUrl } from './navigation';
import { jsx as _jsx } from "react/jsx-runtime";
export function mapAutocompleteItem(acCard) {
  if (acCard.resultType === 'LISTING') {
    const listing = acCard.listing.card;
    return {
      base: acCard,
      id: String(listing.listingId),
      image: /*#__PURE__*/_jsx(Image, {
        src: listing.iconUrl,
        blockSize: "32px",
        borderRadius: "100"
      }),
      subtitle: unescapedText('marketplaceStorefront.searchBar.searchGroup.listing', {
        displayTagLabel: listing.displayTagLabel,
        companyName: listing.companyName
      }),
      url: buildListingUrl(listing.slug) // TODO: remove !
    };
  }
  if (acCard.resultType === 'QUERY') {
    const query = acCard.query;
    return {
      base: acCard,
      id: `${acCard.resultType} ${acCard.term} ${String(query.queryType)}`,
      image: /*#__PURE__*/_jsx(SearchIcon, {
        size: "400",
        color: "icon-core-subtle"
      }),
      url: buildSearchUrl(acCard)
    };
  }
  if (acCard.resultType === 'CATEGORY') {
    const category = acCard.category;
    return {
      base: acCard,
      id: `${acCard.category} ${String(category.categories[0])}`,
      image: /*#__PURE__*/_jsx(TagIcon, {
        size: "400",
        color: "icon-core-subtle"
      }),
      subtitle: unescapedText('marketplaceStorefront.searchBar.searchGroup.category'),
      url: buildCategoryUrl(acCard)
    };
  }
  if (acCard.resultType === 'COLLECTION') {
    const collection = acCard.collection;
    return {
      base: acCard,
      id: String(collection.collectionId),
      image: /*#__PURE__*/_jsx(FolderOpenIcon, {
        size: "400",
        color: "icon-core-subtle"
      }),
      subtitle: unescapedText('marketplaceStorefront.searchBar.searchGroup.collection'),
      url: buildCollectionUrl(acCard)
    };
  }
  throw new Error(`Unknown AutocompleteCard resultType ${String(acCard.resultType)}`);
}